import { render, staticRenderFns } from "./ListStudentRegister.vue?vue&type=template&id=1041acf6"
import script from "./ListStudentRegister.vue?vue&type=script&lang=js"
export * from "./ListStudentRegister.vue?vue&type=script&lang=js"
import style0 from "./ListStudentRegister.vue?vue&type=style&index=0&id=1041acf6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports